var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"header-title"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"header-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }